import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CalendarPlus, Ticket, TrendingUp, ScanLine, Sparkles, Gift } from "lucide-react";

export default function OrgDashboardPage() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/organizer/stats").then((r) => setStats(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="z-container" style={{ textAlign: "center" }}><span className="z-loader z-loader-dark" /></div>;

  return (
    <div className="z-container" data-testid="org-dashboard-page">
      <h1 className="z-page-title">Bonjour, {user?.name?.split(" ")[0]} 👋</h1>
      <p className="z-page-sub">Vos performances en un coup d'œil.</p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 24 }}>
        <div className="z-kpi"><div className="z-kpi-label">Événements</div><div className="z-kpi-value" data-testid="kpi-events">{stats?.total_events ?? 0}</div></div>
        <div className="z-kpi"><div className="z-kpi-label">À venir</div><div className="z-kpi-value" data-testid="kpi-upcoming">{stats?.upcoming_events ?? 0}</div></div>
        <div className="z-kpi"><div className="z-kpi-label">Billets vendus</div><div className="z-kpi-value" data-testid="kpi-tickets">{stats?.tickets_sold ?? 0}</div></div>
        <div className="z-kpi"><div className="z-kpi-label">Revenus</div><div className="z-kpi-value" data-testid="kpi-revenue">{(stats?.revenue ?? 0).toFixed(0)} €</div></div>
        <div className="z-kpi"><div className="z-kpi-label">Scannés</div><div className="z-kpi-value" data-testid="kpi-scanned">{stats?.tickets_scanned ?? 0}</div></div>
      </div>

      <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>Actions rapides</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 12 }}>
        <Link to="/org/create" className="z-role-card" data-testid="quick-create-event">
          <div className="z-role-icon"><CalendarPlus size={22} /></div>
          <h3>Nouvel événement</h3>
          <p>Créez et publiez en quelques minutes.</p>
        </Link>
        <Link to="/org/events" className="z-role-card" data-testid="quick-manage-events">
          <div className="z-role-icon"><Ticket size={22} /></div>
          <h3>Mes événements</h3>
          <p>Gérer billets, agents, stats.</p>
        </Link>
        <Link to="/org/engagement" className="z-role-card" data-testid="quick-engagement">
          <div className="z-role-icon"><Sparkles size={22} /></div>
          <h3>Lancer un engagement</h3>
          <p>Cagnotte, vote ou sondage.</p>
        </Link>
        <Link to="/org/vouchers" className="z-role-card" data-testid="quick-vouchers">
          <div className="z-role-icon"><Gift size={22} /></div>
          <h3>Bons d'achat</h3>
          <p>Émettre, distribuer, scanner.</p>
        </Link>
      </div>
    </div>
  );
}
